module.exports = __webpack_public_path__ + "static/img/cert-card.f3aa655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cert-card.png
// module id = feO0
// module chunks = 0